import React from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { userexperience } from "./getconstdata";

const UserExperience = ({ getData, getOnSave }) => {
  const onSelect = (value) => {
    getOnSave("userexperience", value);
  };

  return (
    <>
      <section className="userExperienceSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>3. How Many Years Of Experience Do You Have?</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormControl component="fieldset" className="expRadio">
                <RadioGroup
                  aria-label="userexperience"
                  defaultValue="less3"
                  name="radio-buttons-group"
                  onChange={(e) => onSelect(e.target.value)}
                  value={getData}
                >
                  {userexperience.map((s) => (
                    <FormControlLabel
                      value={s.value}
                      className="radioLabel"
                      control={<Radio />}
                      label={s.label}
                      key={s.value}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserExperience;
